import React, { useEffect, useState } from "react";
import { useForm } from 'react-hook-form';

// components
import { Button, FormGroup, Row, Col, Spinner } from "reactstrap";
import Select from 'react-select'
import InputDatePickerMesAno from "components/Inputs/InputDatePickerMesAno";
import { CSVLink } from "react-csv";
import MaterialTable from 'material-table';
import { table_translate } from "constants/MaterialTable.js";

// utils
import { showMessage } from "utils/message.js";
import { getSessionCookie } from 'utils/cookies';
import { formateMesAno, formateDateByMesAno } from "utils/formats";

// api
import dadosimplantacaotim_api from 'api/dadosimplantacaotim_api';
import dre_api from "api/dre_api";

export default function ExportarDREMensal({ history }) {

    const { register } = useForm({ mode: "onBlur" });

    var session = getSessionCookie();

    const exportRef = React.useRef(null);

    const [showLoading, setshowLoading] = useState(false);

    const [startDate, setStartDate] = useState(formateDateByMesAno(session.mesAnoDefault));
    const [endDate, setEndDate] = useState(formateDateByMesAno(session.mesAnoDefault));


    // Regional
    const [options_regionais, set_options_regionais] = useState([]);
    const loadOptionsRegionais = () => {
        dadosimplantacaotim_api.getRegionais().then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                let _regionais = [];
                _regionais.push({ label: 'Todas', value: "Todas" });
                result.data.map((m) => _regionais.push({ label: m, value: m }));
                set_options_regionais(_regionais);
                if (_regionais.length == 1) {
                    set_regional(_regionais[0].value);
                    loadOptionsGruposEconomicos(_regionais[0].value);
                }
            }
        })
    }
    const [regional, set_regional] = useState(null);
    const handleChangeRegional = (value) => {
        set_regional(value.value);
        loadOptionsGruposEconomicos(value.value);
    }

    // Grupos Econômicos
    const [options_gruposeconomicos, set_options_gruposeconomicos] = useState([]);
    const loadOptionsGruposEconomicos = (_regional) => {
        dadosimplantacaotim_api.getGruposEconomicos(_regional).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                let _gruposeconomicos = [];
                _gruposeconomicos.push({ label: 'Todos', value: "Todos" });
                result.data.map((m) => _gruposeconomicos.push({ label: m, value: m }));
                set_options_gruposeconomicos(_gruposeconomicos);
                if (_gruposeconomicos.length == 1) {
                    set_grupoeconomico(_gruposeconomicos[0].value);
                }
            }
        })
    }
    const [grupoeconomico, set_grupoeconomico] = useState(null);
    const handleChangeGrupoEconomico = (value) => {
        set_grupoeconomico(value.value);
    }

    // Status
    const options_status = [
        { label: "Todos", value: "Todos" },
        { label: "Finalizado", value: "Finalizado" },
        { label: "Parcial", value: "Parcial" },
        { label: "Pendente", value: "Pendente" }
    ];
    const [status, set_status] = useState(null);
    const handleChangeStatus = (value) => {
        set_status(value);
    }

    useEffect(() => {
        loadOptionsRegionais();
    }, []);

    const [list_table, set_list_table] = useState([]);
    const handleFiltrar = () => {
        if (!regional || !grupoeconomico || !status) {
            showMessage("Aviso", "Todos os campos são obrigatórios", 'error', null);
            return;
        }

        //Validação para o período máximo a ser buscado: 6 meses
        const diffInMonths = (endDate.getFullYear() - startDate.getFullYear()) * 12 + (endDate.getMonth() - startDate.getMonth());
        if (diffInMonths >= 6) {
            showMessage("Aviso", "Período selecionado não pode ser superior a 6 meses!", 'error', null);
            return
        }

        let body = {
            regional: regional,
            grupoEconomico: grupoeconomico,
            situacao: status,
            inicioData: startDate,
            fimData: endDate
        }
        set_list_table([]);

        setshowLoading(true);
        dre_api.getIndicador(body).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                if (result.data.length == 0) {
                    showMessage("Aviso", "Não existem dados para os filtros informados", 'error', null);
                    return;
                }
                set_list_table(result.data);
            }
        })
    }

    const headersExport = [
        { label: 'Regional', key: 'regional' },
        { label: 'Grupo Econômico', key: 'grupoEconomico' },
        { label: 'NickName', key: 'nickName' },
        { label: 'CustCode', key: 'custCode' },
        { label: 'Mês/Ano', key: 'mesAno' },
        { label: 'Faturamento - Aparelho - Quantidade', key: 'faturamento_Aparelho_Quantidade' },
        { label: 'Faturamento - Aparelho - TotalVendas', key: 'faturamento_Aparelho_TotalVendas' },
        { label: 'Faturamento - Aparelho - CMV', key: 'faturamento_Aparelho_CMV' },
        { label: 'Faturamento - Aparelho - TKM', key: 'faturamento_Aparelho_TKM' },
        { label: 'Faturamento - Aparelho - TKM - CMV', key: 'faturamento_Aparelho_TKM_CMV' },
        { label: 'Faturamento - Acessório - Quantidade', key: 'faturamento_Acessorio_Quantidade' },
        { label: 'Faturamento - Acessório - TotalVendas', key: 'faturamento_Acessorio_TotalVendas' },
        { label: 'Faturamento - Acessório - CMV', key: 'faturamento_Acessorio_CMV' },
        { label: 'Faturamento - Acessório - TKM', key: 'faturamento_Acessorio_TKM' },
        { label: 'Faturamento - Acessório - TKM - CMV', key: 'faturamento_Acessorio_TKM_CMV' },
        { label: 'Faturamento - Chip - Quantidade', key: 'faturamento_Chip_Quantidade' },
        { label: 'Faturamento - Chip - TotalVendas', key: 'faturamento_Chip_TotalVendas' },
        { label: 'Faturamento - Chip - CMV', key: 'faturamento_Chip_CMV' },
        { label: 'Faturamento - Chip - TKM', key: 'faturamento_Chip_TKM' },
        { label: 'Faturamento - Chip - TKM - CMV', key: 'faturamento_Chip_TKM_CMV' },
        { label: 'Faturamento - Seguro - Quantidade', key: 'faturamento_Seguro_Quantidade' },
        { label: 'Faturamento - Seguro - TotalVendas', key: 'faturamento_Seguro_TotalVendas' },
        { label: 'Faturamento - Seguro - TKM', key: 'faturamento_Seguro_TKM' },
        { label: 'Faturamento - Seguro - Venda Líquida', key: 'faturamento_Seguro_VendaLiquida' },
        { label: 'Receita - Serviços - Comissão', key: 'receita_Servicos_Comissao' },
        { label: 'Receita - Serviços - ADM', key: 'receita_Servicos_ADM' },
        { label: 'Receita - Serviços - PriceBack', key: 'receita_Servicos_PriceBack' },
        { label: 'Receita - Serviços - PriceOferta', key: 'receita_Servicos_PriceOferta' },
        { label: 'Receita - Serviços - PriceProtection', key: 'receita_Servicos_PriceProtection' },
        { label: 'Receita - Serviços - Rebate', key: 'receita_Servicos_Rebate' },
        { label: 'Receita - Serviços - Recarga', key: 'receita_Servicos_Recarga' },
        { label: 'Receita - Serviços - Outros', key: 'receita_Servicos_Outros' },
        { label: 'Impostos - ISS', key: 'impostos_Servico' },
        { label: 'Impostos - ICMS - Aparelho', key: 'impostos_ICMS_Aparelho' },
        { label: 'Impostos - ICMS - Acessório', key: 'impostos_ICMS_Acessorio' },
        { label: 'Impostos - ICMS - Chip', key: 'impostos_ICMS_Chip' },
        { label: 'Impostos - ICMS-ST - Aparelho', key: 'impostos_ICMSST_Aparelhos' },
        { label: 'Impostos - PIS/COFINS - Aparelho', key: 'impostos_PISCOFINS_Aparelho' },
        { label: 'Impostos - PIS/COFINS - Acessório', key: 'impostos_PISCOFINS_Acessorio' },
        { label: 'Impostos - PIS/COFINS - Chip', key: 'impostos_PISCOFINS_Chip' },
        { label: 'Impostos - PIS/COFINS - Serviço', key: 'impostos_PISCOFINS_Servico' },
        { label: 'Impostos - PIS/COFINS - Recarga', key: 'impostos_PISCOFINS_Recarga' },
        { label: 'Impostos - PIS/COFINS - Seguro', key: 'impostos_PISCOFINS_Seguro' },
        { label: 'Impostos - Simples Nacional', key: 'impostos_SimplesNacional' },
        { label: 'Compras - Aparelho - Quantidade', key: 'compras_Aparelho_Quantidade' },
        { label: 'Compras - Aparelho - Custo', key: 'compras_Aparelho_Custo' },
        { label: 'Compras - Aparelho - TKM', key: 'compras_Aparelho_TKM' },
        { label: 'Compras - Acessórios - Quantidade', key: 'compras_Acessorios_Quantidade' },
        { label: 'Compras - Acessórios - Custo', key: 'compras_Acessorios_Custo' },
        { label: 'Compras - Acessórios - TKM', key: 'compras_Acessorios_TKM' },
        { label: 'Compras - Chip - Quantidade', key: 'compras_Chip_Quantidade' },
        { label: 'Compras - Chip - Custo', key: 'compras_Chip_Custo' },
        { label: 'Compras - Chip - TKM', key: 'compras_Chip_TKM' },
        { label: 'Vendedores - Quantidade', key: 'vendedores_Quantidade' },
        { label: 'Vendedores - Salário', key: 'vendedores_Salario' },
        { label: 'Vendedores - Comissão', key: 'vendedores_Comissao' },
        { label: 'Vendedores - Outros Pessoal', key: 'vendedores_OutrosPessoal' },
        { label: 'Vendedores - Férias', key: 'vendedores_Ferias' },
        { label: 'Vendedores - INSS', key: 'vendedores_INSS' },
        { label: 'Vendedores - FGTS', key: 'vendedores_FGTS' },
        { label: 'Vendedores - Imposto De Renda', key: 'vendedores_ImpostoDeRenda' },
        { label: 'Vendedores - Decimo Terceiro Salario', key: 'vendedores_DecimoTerceiroSalario' },
        { label: 'Vendedores - Verba Recisoria', key: 'vendedores_VerbaRecisoria' },
        { label: 'Vendedores - Vale Alimentação', key: 'vendedores_ValeAlimentacao' },
        { label: 'Vendedores - Vale Refeição', key: 'vendedores_ValeRefeicao' },
        { label: 'Vendedores - Vale Transporte', key: 'vendedores_ValeTransporte' },
        { label: 'Vendedores - Contribuição Sindical', key: 'vendedores_ContribuicaoSindical' },
        { label: 'Vendedores - Seguro DeVida', key: 'vendedores_SeguroDeVida' },
        { label: 'Vendedores - Plano Saude', key: 'vendedores_PlanoSaude' },
        { label: 'Vendedores - Plano Odontologico', key: 'vendedores_PlanoOdontologico' },
        { label: 'Vendedores - Incentivo Estudos', key: 'vendedores_IncentivoEstudos' },
        { label: 'Gerentes - Quantidade', key: 'gerentes_Quantidade' },
        { label: 'Gerentes - Salário', key: 'gerentes_Salario' },
        { label: 'Gerentes - Comissão', key: 'gerentes_Comissao' },
        { label: 'Gerentes - Outros Pessoal', key: 'gerentes_OutrosPessoal' },
        { label: 'Gerentes - Férias', key: 'gerentes_Ferias' },
        { label: 'Gerentes - INSS', key: 'gerentes_INSS' },
        { label: 'Gerentes - FGTS', key: 'gerentes_FGTS' },
        { label: 'Gerentes - Imposto De Renda', key: 'gerentes_ImpostoDeRenda' },
        { label: 'Gerentes - Decimo Terceiro Salario', key: 'gerentes_DecimoTerceiroSalario' },
        { label: 'Gerentes - Verba Recisoria', key: 'gerentes_VerbaRecisoria' },
        { label: 'Gerentes - Vale Alimentação', key: 'gerentes_ValeAlimentacao' },
        { label: 'Gerentes - Vale Refeição', key: 'gerentes_ValeRefeicao' },
        { label: 'Gerentes - Vale Transporte', key: 'gerentes_ValeTransporte' },
        { label: 'Gerentes - Contribuição Sindical', key: 'gerentes_ContribuicaoSindical' },
        { label: 'Gerentes - Seguro DeVida', key: 'gerentes_SeguroDeVida' },
        { label: 'Gerentes - Plano Saude', key: 'gerentes_PlanoSaude' },
        { label: 'Gerentes - Plano Odontologico', key: 'gerentes_PlanoOdontologico' },
        { label: 'Gerentes - Incentivo Estudos', key: 'gerentes_IncentivoEstudos' },
        { label: 'Caixas - Quantidade', key: 'caixas_Quantidade' },
        { label: 'Caixas - Salário', key: 'caixas_Salario' },
        { label: 'Caixas - Comissão', key: 'caixas_Comissao' },
        { label: 'Caixas - Outros Pessoal', key: 'caixas_OutrosPessoal' },
        { label: 'Caixas - Férias', key: 'caixas_Ferias' },
        { label: 'Caixas - INSS', key: 'caixas_INSS' },
        { label: 'Caixas - FGTS', key: 'caixas_FGTS' },
        { label: 'Caixas - Imposto De Renda', key: 'caixas_ImpostoDeRenda' },
        { label: 'Caixas - Decimo Terceiro Salario', key: 'caixas_DecimoTerceiroSalario' },
        { label: 'Caixas - Verba Recisoria', key: 'caixas_VerbaRecisoria' },
        { label: 'Caixas - Vale Alimentação', key: 'caixas_ValeAlimentacao' },
        { label: 'Caixas - Vale Refeição', key: 'caixas_ValeRefeicao' },
        { label: 'Caixas - Vale Transporte', key: 'caixas_ValeTransporte' },
        { label: 'Caixas - Contribuição Sindical', key: 'caixas_ContribuicaoSindical' },
        { label: 'Caixas - Seguro DeVida', key: 'caixas_SeguroDeVida' },
        { label: 'Caixas - Plano Saude', key: 'caixas_PlanoSaude' },
        { label: 'Caixas - Plano Odontologico', key: 'caixas_PlanoOdontologico' },
        { label: 'Caixas - Incentivo Estudos', key: 'caixas_IncentivoEstudos' },
        { label: 'Administrativo - Quantidade', key: 'administrativo_Quantidade' },
        { label: 'Administrativo - Salário', key: 'administrativo_Salario' },
        { label: 'Administrativo - Comissão', key: 'administrativo_Comissao' },
        { label: 'Administrativo - Outros Pessoal', key: 'administrativo_OutrosPessoal' },
        { label: 'Administrativo - Férias', key: 'administrativo_Ferias' },
        { label: 'Administrativo - INSS', key: 'administrativo_INSS' },
        { label: 'Administrativo - FGTS', key: 'administrativo_FGTS' },
        { label: 'Administrativo - Imposto De Renda', key: 'administrativo_ImpostoDeRenda' },
        { label: 'Administrativo - Decimo Terceiro Salario', key: 'administrativo_DecimoTerceiroSalario' },
        { label: 'Administrativo - Verba Recisoria', key: 'administrativo_VerbaRecisoria' },
        { label: 'Administrativo - Vale Alimentação', key: 'administrativo_ValeAlimentacao' },
        { label: 'Administrativo - Vale Refeição', key: 'administrativo_ValeRefeicao' },
        { label: 'Administrativo - Vale Transporte', key: 'administrativo_ValeTransporte' },
        { label: 'Administrativo - Contribuição Sindical', key: 'administrativo_ContribuicaoSindical' },
        { label: 'Administrativo - Seguro DeVida', key: 'administrativo_SeguroDeVida' },
        { label: 'Administrativo - Plano Saude', key: 'administrativo_PlanoSaude' },
        { label: 'Administrativo - Plano Odontologico', key: 'administrativo_PlanoOdontologico' },
        { label: 'Administrativo - Incentivo Estudos', key: 'administrativo_IncentivoEstudos' },
        { label: 'Despesa Ocupação - Aluguel', key: 'despesaOcupacao_Aluguel' },
        { label: 'Despesa Ocupação - Condomínio', key: 'despesaOcupacao_Condominio' },
        { label: 'Despesa Ocupação - Fundo Promoção', key: 'despesaOcupacao_FundoPromocao' },
        { label: 'Despesa Ocupação - Aluguel Percentual', key: 'despesaOcupacao_AluguelPercentual' },
        { label: 'Despesa Ocupação - Decimo Terceiro Aluguel', key: 'despesaOcupacao_DecimoTerceiroAluguel' },
        { label: 'Despesa Ocupação - IPTU', key: 'despesaOcupacao_IPTU' },
        { label: 'Despesa Ocupação - Credito PIS COFINS', key: 'despesaOcupacao_CreditoPISCOFINS' },
        { label: 'Despesa Ocupação - Outras de Ocupação', key: 'despesaOcupacao_Outras' },
        { label: 'Despesa Estrutural - Telefonia e Internet', key: 'despesaEstrutural_Telefoniainternet' },
        { label: 'Despesa Estrutural - Limpeza', key: 'despesaEstrutural_Limpeza' },
        { label: 'Despesa Estrutural - Manutenção', key: 'despesaEstrutural_Manutencao' },
        { label: 'Despesa Estrutural - Energia', key: 'despesaEstrutural_Energia' },
        { label: 'Despesa Estrutural - Materiais', key: 'despesaEstrutural_Materiais' },
        { label: 'Despesa Estrutural - Contabilidade', key: 'despesaEstrutural_Contabilidade' },
        { label: 'Despesa Estrutural - Jurídico', key: 'despesaEstrutural_Juridico' },
        { label: 'Despesa Estrutural - Sistemas', key: 'despesaEstrutural_Sistemas' },
        { label: 'Despesa Estrutural - Ações de Vendas', key: 'despesaEstrutural_AcoesVendas' },
        { label: 'Despesa Estrutural - Seguro', key: 'despesaEstrutural_Seguro' },
        { label: 'Despesa Estrutural - Motoboy', key: 'despesaEstrutural_Motoboy' },
        { label: 'Despesa Estrutural - Outros', key: 'despesaEstrutural_Outros' },
        { label: 'Despesa Estrutural - Eventos', key: 'despesaEstrutural_Eventos' },
        { label: 'Despesa Estrutural - Água e Esgoto', key: 'despesaEstrutural_SaneamentoBasico' },
        { label: 'Despesa Estrutural - Segurança Monitoramento', key: 'despesaEstrutural_SegurancaMonitoramento' },
        { label: 'Despesa Estrutural - Contribuição Sindical', key: 'despesaEstrutural_ContribuicaoSindical' },
        { label: 'Despesa Estrutural - Empresa Terceirizada', key: 'despesaEstrutural_EmpresaTerceirizada' },
        { label: 'Despesa Estrutural - Uniformes', key: 'despesaEstrutural_Uniformes' },
        { label: 'Despesa Estrutural - Recrutamento Seleção', key: 'despesaEstrutural_RecrutamentoSelecao' },
        { label: 'Despesa Estrutural - Processo Judicial', key: 'despesaEstrutural_ProcessoJudicial' },
        { label: 'Despesa Estrutural - Despesa Grafica', key: 'despesaEstrutural_DespesaGrafica' },
        { label: 'Despesa Estrutural - Fretes Carreto', key: 'despesaEstrutural_FretesCarreto' },
        { label: 'Despesa Estrutural - Representacoes Viagens Transporte', key: 'despesaEstrutural_RepresentacoesViagensTransporte' },
        { label: 'Despesa Estrutural - IR Aluguel', key: 'despesaEstrutural_IRAluguel' },
        { label: 'Despesa Estrutural - Perda Roubo Baixa Estoque', key: 'despesaEstrutural_PerdaRouboBaixaEstoque' },
        { label: 'Despesa Cartão - Taxa Cartão', key: 'despesaBancaria_TaxaCartaoMDR' },
        { label: 'Despesa Cartão - Aluguel Maquina', key: 'despesaBancaria_AluguelMaquina' },
        { label: 'Pos Ebitda - Tarifas Bancárias', key: 'posEbitda_TarifasBancarias' },
        { label: 'Pos Ebitda - Amortização Intangivel', key: 'posEbitda_AmortizacaoIntangivel' },
        { label: 'Pos Ebitda - Antecipação Recebiveis', key: 'posEbitda_AntecipacaoRecebiveis' },
        { label: 'Pos Ebitda - Depreciação', key: 'posEbitda_Depreciacao' },
        { label: 'Pos Ebitda - Despesa Bancaria', key: 'posEbitda_DespesaBancaria' },
        { label: 'Pos Ebitda - IOF', key: 'posEbitda_IOF' },
        { label: 'Pos Ebitda - Juros Emprestimo Bancario', key: 'posEbitda_JurosEmprestimoBancario' },
        { label: 'Pos Ebitda - Juros Pagos Incorridos', key: 'posEbitda_JurosPagosIncorridos' },
        { label: 'Pos Ebitda - Outras Financeiras', key: 'posEbitda_Outras' },
        { label: 'Volume Pós', key: 'ativacoes_PosPuro' },
        { label: 'Volume Fixo', key: 'ativacoes_Fixo' },
        { label: 'Volume Controle', key: 'ativacoes_Controle' },
        { label: 'Volume Pré-Pago', key: 'ativacoes_PrePago' },
        { label: 'Volume Upgrade Controle-Pós Puro', key: 'ativacoes_Upgrade' },
        { label: 'Volume Upgrade Pós Puro-Pós Puro', key: 'ativacoes_MigracaoPos' },
        { label: 'Volume Upgrade Controle-Controle', key: 'ativacoes_MigracaoControle' }
    ]
    const [csvData, set_csvData] = useState([]);

    const handleExportar = () => {
        if (!regional || !grupoeconomico) {
            showMessage("Aviso", "Os campos Regional e Grupo Econômico são obrigatórios", 'error', null);
            return;
        }

        let body = {
            regional: regional,
            grupoEconomico: grupoeconomico,
            situacao: "",
            inicioData: startDate,
            fimData: endDate
        }

        setshowLoading(true);
        dre_api.getExport(body).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                if (result.data.length == 0) {
                    showMessage("Aviso", "Não existem dados para os filtros informados", 'error', null);
                    return;
                }
                set_csvData(result.data);
                exportRef.current.link.click();
            }
        })
    }

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }
            <div className="content">
                <Row className="mb-4 align-items-end">
                    <Col lg="2" md="6" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Regional</label>
                            <Select
                                name="regional"
                                options={options_regionais}
                                getOptionLabel={o => o.label}
                                getOptionValue={o => o.value}
                                value={options_regionais.filter(f => f.value == regional)}
                                onChange={(o) => handleChangeRegional(o)}
                                classNamePrefix="select"
                                placeholder="[ Selecione ]"
                                ref={e => register({ name: "regional" })
                                }
                            />
                        </FormGroup>
                    </Col>
                    <Col lg="4" md="6" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Grupo Econômico</label>
                            <Select
                                name="grupoeconomico"
                                options={options_gruposeconomicos}
                                getOptionLabel={o => o.label}
                                getOptionValue={o => o.value}
                                value={options_gruposeconomicos.filter(f => f.value == grupoeconomico)}
                                onChange={(o) => handleChangeGrupoEconomico(o)}
                                classNamePrefix="select"
                                placeholder="[ Selecione ]"
                                ref={e => register({ name: "grupoeconomico" })
                                }
                            />
                        </FormGroup>
                    </Col>
                    <Col lg="2" md="6" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Status</label>
                            <Select
                                name="status"
                                options={options_status}
                                getOptionLabel={o => o.label}
                                getOptionValue={o => o.value}
                                value={options_status.filter(f => f.value == status)}
                                onChange={(o) => handleChangeStatus(o.value)}
                                classNamePrefix="select"
                                placeholder="[ Selecione ]"
                                ref={e => register({ name: "status" })
                                }
                            />
                        </FormGroup>
                    </Col>
                    <Col lg="2" md="6" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Mês/Ano (inicial)</label>
                            <InputDatePickerMesAno selected={startDate} onChange={(date) => setStartDate(date)} ></InputDatePickerMesAno>
                        </FormGroup>
                    </Col>
                    <Col lg="2" md="4" sm="12">
                        <FormGroup>
                            <label className="form-control-label">Mês/Ano (final)</label>
                            <InputDatePickerMesAno selected={endDate} onChange={(date) => setEndDate(date)} ></InputDatePickerMesAno>
                        </FormGroup>
                    </Col>
                    <Col lg="2" md="6" sm="12">
                        <Button color="info" type="button" onClick={handleFiltrar}><i className="fas fa-filter"></i>  Filtrar</Button>
                    </Col>
                </Row>
                {list_table.length > 0 &&
                    <>
                        {(status == "Todos" || status == "Finalizado") &&
                            <Row>
                                <Col lg="12" md="12" sm="12" className="text-right">
                                    <Button color="success" type="button" onClick={handleExportar}><i className="fas fa-download"></i>  Exportar</Button>
                                    {csvData.length > 0 &&
                                        <CSVLink data={csvData} headers={headersExport} filename="DRE Mensal.csv" target="_blank" ref={exportRef}></CSVLink>
                                    }
                                </Col>
                            </Row>
                        }
                        <MaterialTable style={{ minHeight: "auto" }}
                            title=""
                            columns={[
                                { title: 'Mês/Ano', field: 'mesAno' },
                                { title: 'Regional', field: 'regional' },
                                { title: 'Grupo Econômico', field: 'grupoEconomico' },
                                { title: 'Nick Name', field: 'nickName' },
                                { title: 'Cust Code', field: 'custCode' },
                                { title: 'Situação', field: 'status' }
                            ]}
                            data={list_table}
                            isLoading={false}
                            localization={table_translate}
                            options={{
                                filtering: false,
                                exportButton: false,
                                paging: false,
                                headerStyle: {
                                    fontFamily: 'Montserrat, Helvetica Neue, Arial, sans-serif',
                                    fontWeight: '700',
                                    color: '#fff',
                                    backgroundColor: "#0b3d86",
                                    paddingTop: '5px',
                                    paddingBottom: '5px',
                                    zIndex: 0
                                },
                            }}
                        />
                    </>
                }
            </div>
        </>

    );
}
